import type MockAdapter from 'axios-mock-adapter'
import { actionConfig, componentPermissions, setSubmission, WorkflowError } from '../engine/workflowEngine'

/**
 * Endpoint Workflow Studio yang dipakai komponen `WorkflowStudioContainer` dan
 * `WorkflowStudioActionButton`, plus `POST /api/workflow/submission/v2`.
 */

const COMPONENT_PERMISSION = /^\/api\/workflow\/component_permission\/([^/]+)(?:\/([^/?]+))?\/?$/
const ACTION_CONFIG = /^\/api\/workflow\/action-config\/([^/]+)\/([^/?]+)\/?$/

export const toErrorResponse = (error: unknown) => {
  if (error instanceof WorkflowError) {
    return [error.status, { statusCode: error.status, code: error.code, message: error.message }]
  }
  return [500, { statusCode: 500, code: 'LOCAL_DB_ERROR', message: String(error) }]
}

export function registerWorkflowHandlers(mock: MockAdapter, currentRoleId: () => string) {
  mock.onGet(COMPONENT_PERMISSION).reply(config => {
    const [, workflowCode, submissionId] = COMPONENT_PERMISSION.exec(config.url ?? '') ?? []
    const roleId = String(config.params?.roleId ?? '') || currentRoleId()
    return [200, { data: componentPermissions(workflowCode, submissionId, roleId) }]
  })

  mock.onGet(ACTION_CONFIG).reply(config => {
    const [, workflowCode, componentCode] = ACTION_CONFIG.exec(config.url ?? '') ?? []
    try {
      return [200, { data: actionConfig(workflowCode, componentCode, currentRoleId()) }]
    } catch (error) {
      return toErrorResponse(error)
    }
  })

  mock.onPost('/api/workflow/submission/v2').reply(config => {
    try {
      const payload = JSON.parse(String(config.data ?? '{}'))
      return [200, { statusCode: 200, success: true, message: 'Submission berhasil.', data: setSubmission(payload) }]
    } catch (error) {
      return toErrorResponse(error)
    }
  })
}
